import keyboardSilverImage2 from '../../assets/keyboard-silver-2.png'
import keyboardSilverImage3 from '../../assets/keyboard-silver-3.png'
import './Header.scss'

const Header = ({ isMobile = false }) => {
  return (
    <div className={'header-container' + (isMobile ? '' : ' isDesktop')}>
      {isMobile && (
        <img
          src={isMobile ? keyboardSilverImage2 : keyboardSilverImage3}
          className={'keyboard2' + (isMobile ? '' : ' isDesktop')}
          alt="keyboard silver"
        />
      )}
    </div>
  )
}

export default Header
